import { render, staticRenderFns } from "./ContractNotes.vue?vue&type=template&id=80407df4&scoped=true&"
import script from "./ContractNotes.vue?vue&type=script&lang=js&"
export * from "./ContractNotes.vue?vue&type=script&lang=js&"
import style0 from "./ContractNotes.vue?vue&type=style&index=0&id=80407df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80407df4",
  null
  
)

export default component.exports